import React from 'react';
import { useAppSelector } from '../../../contexts/hooks';
import { shallowEqual } from 'react-redux';
import moment from 'moment';

interface PatientInfoProps {
  patientData: any;
}

export const PatientInfo: React.FC<PatientInfoProps> = ({ patientData }) => {
  const dateFormat = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'DateTimeClientFormat')[0]?.Cgn_Resultado, shallowEqual);
  const cmb = useAppSelector((x) => x.configuration.Data?.ComboBox, shallowEqual);
  const systemFields = useAppSelector((x) => x.configuration.Data?.SystemFields, shallowEqual);

  const patientFields = systemFields?.filter((x) => x.Dfc_Tabla === 'Pacientes' && x.Dfc_Estado === true && x.Dfc_Visible).sort((a, b) => a.Dfc_Orden - b.Dfc_Orden);

  const renderValue = (field, value) => {
    if (!value) return '---';

    if (field.TipoCampo.Tcm_Equivalencia === 'dxDateBox') {
      return moment(value).format(dateFormat?.toUpperCase() || 'DD/MM/YYYY');
    }
    if (field.TipoCampo.Tcm_Equivalencia === 'dxSwitch' || field.TipoCampo.Tcm_Equivalencia === 'dxCheckBox') {
      return value === 'true' ? 'SÍ' : 'NO';
    }
    if (field.TipoCampo.Tcm_Equivalencia === 'dxSelectBox') {
      const cmbActual = cmb?.filter((x) => x.Name === field.TablasComboBox?.Tbc_NombreTabla)[0];
      const combo = cmbActual?.Data;
      if (combo && combo.length > 0) {
        const item = combo.find((x) => x[field.TablasComboBox.Tbc_CampoId] === parseInt(value));
        return item ? item[field.TablasComboBox.Tbc_CampoVisible] : value;
      }
    }
    return value;
  };

  if (!patientData) {
    return <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>No hay datos del paciente</div>;
  }

  return (
    <div style={{ padding: '15px', borderTop: '1px solid #e0e0e0' }}>
      <div style={{ marginBottom: '10px', paddingBottom: '8px', borderBottom: '2px solid #28a745' }}>
        <h4 style={{ margin: '0', color: '#28a745', fontSize: '13px', fontWeight: 'bold' }}>Información del Paciente</h4>
      </div>      
      <div key={99999} style={{ marginBottom: '8px' }}>
        <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px', fontWeight: 'bold' }}>Identificación</div>
        <div style={{ fontSize: '12px' }}>{patientData.Pc_Identificacion}</div>
      </div>
      {patientFields?.map((field) => {
        const value = field.Dfc_Dinamico && patientData.AditionalFields ? patientData.AditionalFields[field.Dfc_Equivalencia] : patientData[field.Dfc_Equivalencia];

        return (
          <div key={field.Dfc_Id} style={{ marginBottom: '8px' }}>
            <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px', fontWeight: 'bold' }}>{field.Dfc_Label}</div>
            <div style={{ fontSize: '12px' }}>{renderValue(field, value)}</div>
          </div>
        );
      })}
    </div>
  );
};
